import { css } from 'styled-components';

import { Color } from 'style/types';

export const unitMapping = {
  0: '0px',
  0.5: 'var(--half-unit)',
  1: 'var(--unit)',
  1.5: 'var(--intermediate-unit)',
  2: 'var(--double-unit)',
  2.5: 'var(--double-and-a-half-unit)',
  3: 'var(--triple-unit)',
  4: 'var(--quadruple-unit)',
  5: 'calc(5 * var(--unit))',
  6: 'calc(6 * var(--unit))',
  7: 'calc(7 * var(--unit))',
  8: 'calc(8 * var(--unit))',
  10: 'calc(10 * var(--unit))',
} as const;

export const absCenter = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

type GridBackgroundArgs = {
  bgColor?: Color;
  gridColor?: Color;
  cellSize?: number;
};
export const gridBackground = ({
  bgColor = 'var(--c-black)',
  gridColor = 'var(--c-nd-150)',
  cellSize = 40,
}: GridBackgroundArgs) => `
  repeating-linear-gradient(
    to right,
    transparent 0px,
    transparent ${cellSize - 1}px,
    ${gridColor} ${cellSize}px
  ),
  repeating-linear-gradient(
    to bottom,
    ${bgColor} 0px,
    ${bgColor} ${cellSize - 1}px,
    ${gridColor} ${cellSize}px
  )
`;
